import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-950 text-white px-4 py-16">
      {/* Hero Section */}
      <div className="text-center">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-2xl mb-4">Challenge Failed!</p>
        <p className="text-lg mb-8">The page you're looking for doesn't exist or has been moved.</p>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 mb-12">
        <Link
          to="/compare"
          className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg hover:bg-yellow-300 transition"
        >
          Compare Prop Firms
        </Link>
        <Link
          to="/reviews"
          className="border border-yellow-400 text-yellow-400 py-3 px-6 rounded-lg hover:bg-yellow-400 hover:text-black transition"
        >
          See Reviews
        </Link>
        <Link
          to="/best-prop-firms"
          className="border border-gray-600 text-gray-300 py-3 px-6 rounded-lg hover:bg-gray-800 transition"
        >
          Best Prop Firms 2025
        </Link>
      </div>

      {/* CTA Section */}
      <div className="w-full max-w-xl bg-gray-900 p-6 rounded-lg border border-gray-800 text-center">
        <h2 className="text-xl font-bold mb-2">Stay Updated</h2>
        <p className="mb-4 text-gray-400">Get the latest prop firm deals, discounts, and reviews — straight to your inbox.</p>
        <Link
          to="/subscribe"
          className="inline-block bg-yellow-400 text-black font-semibold py-2 px-6 rounded hover:bg-yellow-300 transition"
        >
          Subscribe Now
        </Link>
      </div>
    </div>
  );
}
